import { projects } from './data/projectsArray'
import ProjectCard from './ProjectCard'
import { Helmet } from 'react-helmet'
// import  About  from './About'


export default function Projects() {
  // const designProjects = projects.filter((project) => project.type === 'design')
  // const managementProjects = projects.filter((project) => project.type === 'management')


  return (
    <div>

    <Helmet>
      <title>Chris Milburn</title>
      <meta name="keywords" content="lighting design, lighting, design, Sydney"/>
    </Helmet>
      {/* <About /> */}
      <div className='projects_container container'>
        
        {projects.toReversed().map((project) => (
          <ProjectCard key={project.id} name={project.name} heroAlt={project.heroAlt} sourceSet={project.sourceSet} code={project.code} type={project.type[0]} typei18nKey={project.type[1]}/> 
        ))}
      </div>      
    </div>
  )
}
